module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1002-eff69f57860bce6fc8e096e09f46dbc5.png";